export default __webpack_public_path__ + "static/media/014-eartquake.710682b5.svg";